/** Local IPC failure metadata; successful protobuf replies and legacy thrown errors stay compatible. */
export class DirectLinkFailure extends Error {
  constructor(
    readonly operation: 'camera-link-details' | 'camera-status',
    readonly code: number | undefined,
    transport: boolean
  ) {
    super(transport ? 'fetch failed' : 'Camera connection request failed.');
  }
}

/** Decode only our closed local envelope. Never reflect Electron/server error text into the renderer. */
export const decodeDirectLinkResponse = <T>(response: T): T => {
  if (!response || typeof response !== 'object' || !('directLinkFailure' in response))
    return response;
  const failure = response.directLinkFailure;
  if (!failure || typeof failure !== 'object')
    throw new Error('Invalid camera connection response.');
  const fields = failure as { operation?: unknown; status?: unknown; kind?: unknown };
  if (fields.operation !== 'camera-link-details' && fields.operation !== 'camera-status') {
    throw new Error('Invalid camera connection response.');
  }
  const code =
    typeof fields.status === 'number' &&
    [400, 401, 403, 404, 408, 409, 422, 429, 500, 502, 503, 504].includes(fields.status)
      ? fields.status
      : undefined;
  throw new DirectLinkFailure(fields.operation, code, fields.kind === 'transport');
};
